"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var setServerGlobals_exports = {};
__export(setServerGlobals_exports, {
  setServerGlobals: () => setServerGlobals
});
module.exports = __toCommonJS(setServerGlobals_exports);
function setServerGlobals() {
  process.env.VXRN_REACT_19 = "1";
  process.env.VITE_ENVIRONMENT = "ssr";
  globalThis["requestAnimationFrame"] = setTimeout;
}
//# sourceMappingURL=setServerGlobals.js.map
